import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';

// data dependencies
import { REPORT_PART_TYPE } from 'logic/data/Izenda.ReportDesignerConstants';

// module imports
import KPITilePropertiesContainer from 'modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartKPI/Izenda.KPITilePropertiesContainer.jsx'

// share dependencies
import DropDown from 'share/components/controls/Izenda.DropDown';
import FormGroup from 'share/components/controls/Izenda.FormGroup';
import connect from 'share/enhancers/Izenda.Connect.js';

/**
 * @class TilePropertiesContainer
 * @description render tile properties based on report part type
 */
@connect()
class TilePropertiesContainer extends Component {
    /**
     * @method onChangeReport
     * @description callback method for report part dropdown to switch the part being edited
     */
    onChangeReport = (selectedPartTitle, selectedPart) => {
        const reportBody = get('reportDesignerModel.reportFields.reportBody', this.props);
        reportBody && reportBody.setConfigReportPart(selectedPart);
    }

    /**
     * @method renderPropertiesContainer
     * @description render a properties container based on the current active report part type
     */
    renderPropertiesContainer = () => {
        const reportBody = get('reportDesignerModel.reportFields.reportBody', this.props);
        const { configReportPart } = reportBody;

        if (configReportPart.type === REPORT_PART_TYPE.KPI) {
            return (
                <KPITilePropertiesContainer 
                    reportDetails={configReportPart}
                />
            );
        }
    }

    render() {
        const {
            localization,
            reportDesignerModel
        } = this.props;
        const reportBody = get('reportFields.reportBody', reportDesignerModel);
        const { configReportPart, supportReportParts } = reportBody;

        return (
            <section className="form-horizontal">
                <div>
                    <div className="title-group">
                        <strong className="u_inlineBlock">
                            {localization.getText('TILE_PROPERTIES_PANEL_TITLE')}
                        </strong>
                    </div>
                    <FormGroup className="report-parts-ctrl">
                        <DropDown 
                            blankOption
                            options={supportReportParts}
                            onChange={this.onChangeReport}
                            valueField="id"
                            labelField="headerTitle"
                            value={configReportPart && configReportPart.id}
                        />
                    </FormGroup>
                    {this.renderPropertiesContainer()}
                </div>
            </section>
        );
    }
}

TilePropertiesContainer.propTypes = {
    fieldStore: PropTypes.object,
    reportDesignerModel: PropTypes.object
};

export default TilePropertiesContainer;



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/TilePropertiesContainer/Izenda.TilePropertiesContainer.jsx